export const STORAGE_INVENTORY_KEYS = {
  SNAPSHOT: "mt6_storage_inventory_snapshot",
} as const;
